import * as React from 'react'

import { HeroRedesign } from 'sdk/sections/hero-redesign/HeroRedesign'
import wheelIcon from 'shared/assets/icons/wheel.svg'

import type { SoundscapeHeroCmsContent } from 'core/services/cms/interfaces'

import soundscapeHeroBgLarge from '../../assets/soundscape-hero-bg-large.jpg'
import soundscapeHeroBgSmall from '../../assets/soundscape-hero-bg-small.jpg'
import soundscapeHeroBgXsm from '../../assets/soundscape-hero-bg-xsm.jpg'

interface HeroProps {
  content: SoundscapeHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ content }) => {
  return (
    <HeroRedesign
      imageDesktop={soundscapeHeroBgLarge}
      imageTablet={soundscapeHeroBgSmall}
      imageMobile={soundscapeHeroBgXsm}
      pillText={content.pillText}
      pillIcon={wheelIcon}
      titleText={content.titleText}
      description={content.description}
      alwaysCentered
    />
  )
}
